import config from "../../vue.config"
const current_url = location.href
console.log(current_url);
let env = ( current_url.indexOf('w709y1phya.execute') > -1 ? 'dev'
        : current_url.indexOf('5ei1ue4naa.execute') > -1 ? 'qa'
        : current_url.indexOf('0uoumqd0v8.execute') > -1 ? 'production' 
        : current_url.indexOf('test-eco-dev.s3-website-us-east-1.amazonaws.com') > -1 ? 'production' 
        : current_url.indexOf('localhost') > -1 ? 'qa' 
        : current_url.indexOf('dish.com.mx') > -1 ? 'production' 
        : current_url.indexOf('rlvc5z3j2k.execute') > -1 ? 'dishmxdev' 
        : 'qa' )

// -- INIT ---
env = 'production'
// -- END ---

export const environment = {
    END_POINT_URL:  env == 'production' ? 'https://fkervt4enc.execute-api.us-east-1.amazonaws.com/dev/' : 
                    env == 'qa' ? "https://9cffwctn57.execute-api.us-east-1.amazonaws.com/dev" :
                    env == 'localhost' ? "http://localhost:4500/" :
                    env == 'dishmxdev' ? "https://gt8cbeuh87.execute-api.us-east-1.amazonaws.com/dev/" :
                    'https://jkg4eqocv7.execute-api.us-east-1.amazonaws.com/dev/',//QA default
    TOKEN_APP: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwYWdlX2lkIjoxLCJ0eXBlIjoiQVBQIiwiaWF0IjoxNjE3ODQ2MDc3LCJleHAiOjE5Mjg4ODYwNzd9.NCqzyJNbRf1DdGXWO-z-5AshDCMCd0v03AR0-7xuV9w',
    TOKEN_MINUTES_EXPIRES: 300,
    ENV : env
}

export const baseURL =  ( environment.ENV == 'development' ?  `${config.publicPath}json` :  environment.END_POINT_URL )